import axios from "axios";
import { fn_add_box_show } from "../function/FnBodyLayer";
import { fn_address_api, fn_address_api_pos } from "function/FnBodyStep";
import { select_addr_fornaver_detail_check } from "http/addrConn";

const kakaoApiKey = "446c5ee05297c670e927d4ad4418f645";

//주소검색
export function select_addr_forkakao(rootStore) {
  rootStore.viewStore.setAddrApiName("api", "kakao"); //kakao초기화
  rootStore.viewStore.setSearchAddrCount(null);
  rootStore.viewStore.setDetailSearchAddrDetail(""); // 주소 상세 검색란 초기화
  rootStore.viewStore.setKakaoMap("", "");
  if (!rootStore.viewStore.getDetailSearchAddr) {
    rootStore.viewStore.initSearchAddrList();
    return;
  }
  axios
    .get(
      "//dapi.kakao.com/v2/local/search/address.json?query=" +
        rootStore.viewStore.getDetailSearchAddr,
      {
        headers: {
          Authorization: `KakaoAK ${kakaoApiKey}`,
        },
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.documents) {
          let addrArr = [];
          if (res.data.meta != null) {
            for (let i = 0; i < res.data.documents.length; i++) {
              //if (res.data.documents[i].road_address != null && res.data.documents[i].address != null) {
              if (
                res.data.documents[i].road_address != null ||
                res.data.documents[i].address != null
              ) {
                if (res.data.documents[i].address_type != "REGION") {
                  let place_name = " ";
                  let road_name = "";
                  if (res.data.documents[i].place_name != null) {
                    place_name += res.data.documents[i].place_name;
                  }
                  if (res.data.documents[i].road_address != null) {
                    road_name +=
                      res.data.documents[i].road_address.address_name;
                  }
                  addrArr = [
                    ...addrArr,
                    {
                      address:
                        res.data.documents[i].address.address_name + place_name,
                      place_name: place_name,
                      //roadAddress: res.data.documents[i].road_address.address_name,
                      roadAddress: road_name == "undefined" ? "" : road_name,
                      x: res.data.documents[i].x,
                      y: res.data.documents[i].y,
                      id: res.data.documents[i].id,
                    },
                  ];
                }
              }
            }
          }
          if (addrArr.length == 0) {
            rootStore.viewStore.setSearchAddrResult(null);
            select_addr_keyword_forkakao(rootStore);
          } else {
            rootStore.viewStore.setSearchAddrResult("ok");
            rootStore.viewStore.setSearchAddrList(addrArr);
          }
        }
      } else {
        //kakao실패시naver
        fn_address_api(rootStore, "naver");
      }
    })
    .catch((err) => {
      fn_address_api(rootStore, "naver");
    });
}

//키워드 검색 - 주소 없을 경우 검색.
export function select_addr_keyword_forkakao(rootStore) {
  let addrArr = [];

  if (!rootStore.viewStore.getDetailSearchAddr) {
    rootStore.viewStore.initSearchAddrList();
    return;
  }

  axios
    .get(
      "//dapi.kakao.com/v2/local/search/keyword.json?page=1&size=15&analyze_type=exact&query=" +
        rootStore.viewStore.getDetailSearchAddr,
      {
        headers: {
          Authorization: `KakaoAK ${kakaoApiKey}`,
        },
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.documents) {
          if (res.data.meta.total_count === 0) {
            rootStore.viewStore.setSearchAddrResult(null);
            rootStore.viewStore.initSearchAddrList();
          } else {
            rootStore.viewStore.setSearchAddrResult("ok");
            if (res.data.meta != null) {
              for (let i = 0; i < res.data.documents.length; i++) {
                if (
                  res.data.documents[i].address_name != null &&
                  res.data.documents[i].address_name.trim() != "" &&
                  res.data.documents[i].road_address_name != null &&
                  res.data.documents[i].road_address_name.trim() != ""
                ) {
                  let sameCk = addrArr.find(
                    (row) =>
                      row.address === res.data.documents[i].address_name &&
                      row.roadAddress ===
                        res.data.documents[i].road_address_name
                  );
                  let place_name = " ";
                  if (res.data.documents[i].place_name != null) {
                    place_name += res.data.documents[i].place_name;
                  }
                  if (sameCk === undefined) {
                    addrArr = [
                      ...addrArr,
                      {
                        address:
                          res.data.documents[i].address_name + place_name,
                        place_name: place_name,
                        roadAddress: res.data.documents[i].road_address_name,
                        x: res.data.documents[i].x,
                        y: res.data.documents[i].y,
                        id: res.data.documents[i].id,
                      },
                    ];
                  }
                }
              }
            }
            rootStore.viewStore.setSearchAddrList(addrArr);
          }
        }
      }
    })
    .catch((err) => {});
}

export async function select_addr_forkakao_detail_check(
  rootStore,
  searchAddress,
  searchRoadAddress
) {
  if (!rootStore.viewStore.getDetailSearchAddr) {
    rootStore.viewStore.initSearchAddrList();
    return;
  }

  let sendAddr;
  if (searchRoadAddress) {
    sendAddr = searchRoadAddress;
  } else {
    sendAddr = rootStore.viewStore.getDetailSearchAddr;
  }

  let response = await axios
    .get("//dapi.kakao.com/v2/local/search/address.json?query=" + sendAddr, {
      headers: {
        Authorization: `KakaoAK ${kakaoApiKey}`,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.documents) {
          let addrCnt = 0;
          for (let i = 0; i < res.data.documents.length; i++) {
            //if (res.data.documents[i].road_address != null && res.data.documents[i].address != null) {
            if (
              res.data.documents[i].road_address != null ||
              res.data.documents[i].address != null
            ) {
              addrCnt++;
            }
          }
          if (addrCnt >= 1) {
            rootStore.viewStore.setSelectedAddr(res.data.documents[0]);
            return 1;
          } else {
            rootStore.viewStore.setSelectedAddr(null);
            return 0;
          }
        }
      } else {
        select_addr_fornaver_detail_check(rootStore);
      }
    })
    .catch((err) => {});

  return response;
}

// POS 주소 검색
//주소검색
export function select_addr_forkakao_pos(rootStore) {
  rootStore.addressSearchStore.setAddrApiName("api", "kakao");
  rootStore.addressSearchStore.setSearchAddrCount(null);
  rootStore.addressSearchStore.setDetailSearchAddrDetail(""); // 주소 상세 검색란 초기화
  rootStore.addressSearchStore.setKakaoMap("", "");
  if (!rootStore.addressSearchStore.getDetailSearchAddr) {
    rootStore.addressSearchStore.initSearchAddrList();
    return;
  }
  axios
    .get(
      "//dapi.kakao.com/v2/local/search/address.json?query=" +
        rootStore.addressSearchStore.getDetailSearchAddr,
      {
        headers: {
          Authorization: `KakaoAK ${kakaoApiKey}`,
        },
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.documents) {
          let addrArr = [];
          if (res.data.meta != null) {
            for (let i = 0; i < res.data.documents.length; i++) {
              //if (res.data.documents[i].road_address != null && res.data.documents[i].address != null) {
              if (
                res.data.documents[i].road_address != null ||
                res.data.documents[i].address != null
              ) {
                if (res.data.documents[i].address_type != "REGION") {
                  let place_name = " ";
                  let road_name = "";
                  if (res.data.documents[i].place_name != null) {
                    place_name += res.data.documents[i].place_name;
                  }
                  if (res.data.documents[i].road_address != null) {
                    road_name +=
                      res.data.documents[i].road_address.address_name;
                  }
                  addrArr = [
                    ...addrArr,
                    {
                      address:
                        res.data.documents[i].address.address_name + place_name,
                      place_name: place_name,
                      //roadAddress: res.data.documents[i].road_address.address_name,
                      roadAddress: road_name == "undefined" ? "" : road_name,
                      x: res.data.documents[i].x,
                      y: res.data.documents[i].y,
                      id: res.data.documents[i].id,
                    },
                  ];
                }
              }
            }
          }
          if (addrArr.length == 0) {
            rootStore.addressSearchStore.setSearchAddrResult(null);
            select_addr_keyword_forkakao_pos(rootStore);
          } else {
            rootStore.addressSearchStore.setSearchAddrResult("ok");
            rootStore.addressSearchStore.setSearchAddrList(addrArr);
          }
        }
      } else {
        fn_address_api_pos(rootStore, "naver");
      }
    })
    .catch((err) => {
      fn_address_api_pos(rootStore, "naver");
    });
}

//키워드 검색 - 주소 없을 경우 검색.
export function select_addr_keyword_forkakao_pos(rootStore) {
  let addrArr = [];

  if (!rootStore.addressSearchStore.getDetailSearchAddr) {
    rootStore.addressSearchStore.initSearchAddrList();
    return;
  }

  axios
    .get(
      "//dapi.kakao.com/v2/local/search/keyword.json?page=1&size=15&analyze_type=exact&query=" +
        rootStore.addressSearchStore.getDetailSearchAddr,
      {
        headers: {
          Authorization: `KakaoAK ${kakaoApiKey}`,
        },
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.documents) {
          if (res.data.meta.total_count === 0) {
            rootStore.addressSearchStore.setSearchAddrResult(null);
            rootStore.addressSearchStore.initSearchAddrList();
          } else {
            rootStore.addressSearchStore.setSearchAddrResult("ok");
            if (res.data.meta != null) {
              for (let i = 0; i < res.data.documents.length; i++) {
                if (
                  res.data.documents[i].address_name != null &&
                  res.data.documents[i].address_name.trim() != "" &&
                  res.data.documents[i].road_address_name != null &&
                  res.data.documents[i].road_address_name.trim() != ""
                ) {
                  let sameCk = addrArr.find(
                    (row) =>
                      row.address === res.data.documents[i].address_name &&
                      row.roadAddress ===
                        res.data.documents[i].road_address_name
                  );
                  let place_name = " ";
                  if (res.data.documents[i].place_name != null) {
                    place_name += res.data.documents[i].place_name;
                  }
                  if (sameCk === undefined) {
                    addrArr = [
                      ...addrArr,
                      {
                        address:
                          res.data.documents[i].address_name + place_name,
                        place_name: place_name,
                        roadAddress: res.data.documents[i].road_address_name,
                        x: res.data.documents[i].x,
                        y: res.data.documents[i].y,
                        id: res.data.documents[i].id,
                      },
                    ];
                  }
                }
              }
            }
            rootStore.addressSearchStore.setSearchAddrList(addrArr);
          }
        }
      }
    })
    .catch((err) => {});
}

export async function select_addr_forkakao_detail_check_pos(
  rootStore,
  searchAddress,
  searchRoadAddress
) {
  if (!rootStore.addressSearchStore.getDetailSearchAddr) {
    rootStore.addressSearchStore.initSearchAddrList();
    return;
  }

  let sendAddr;
  if (searchRoadAddress) {
    sendAddr = searchRoadAddress;
  } else {
    sendAddr = rootStore.addressSearchStore.getDetailSearchAddr;
  }

  let response = await axios
    .get("//dapi.kakao.com/v2/local/search/address.json?query=" + sendAddr, {
      headers: {
        Authorization: `KakaoAK ${kakaoApiKey}`,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.documents) {
          let addrCnt = 0;
          for (let i = 0; i < res.data.documents.length; i++) {
            //if (res.data.documents[i].road_address != null && res.data.documents[i].address != null) {
            if (
              res.data.documents[i].road_address != null ||
              res.data.documents[i].address != null
            ) {
              addrCnt++;
            }
          }
          if (addrCnt >= 1) {
            rootStore.addressSearchStore.setSelectedAddr(res.data.documents[0]);
            return 1;
          } else {
            rootStore.addressSearchStore.setSelectedAddr(null);
            return 0;
          }
        }
      }
    })
    .catch((err) => {});

  return response;
}
